import styles from './Footer.module.css'

export default function Footer(){
    return(
        <div className={styles.footer}>
            <p>&copy; DevZone Innovations 2025. Todos os direitos reservados.</p>
            <span>Feito por nós mesmos</span>
        </div>
    )
}